module.exports = __webpack_public_path__ + "img/AU.4569fff2.svg";